import React, {Component} from 'react';
import {Input,Form} from "antd";

class NormalInput extends Component {
    constructor(props) {
        super(props);
        this.state={
            title: props.itemValue || "",
        }
    }
    componentDidMount() {
    }


    render() {
        return (

            <Form.Item label={this.props.label} required={this.props.required} style={{display:"flex",alignItems:"center",width:"50%"}} labelCol={{ span: 5 }} wrapperCol={{ span: 10 }} >
                <Input placeholder={this.props.placeholder} className={"normalInput"} value={this.state.title} style={{width:"280px"}} onChange={(e)=>{
                    let title = e.target.value;
                    this.setState({title},()=>{
                        this.props.callBack&& this.props.callBack(title)
                    });
                }}/>
                <style>{`.normalInput{background: rgba(0, 80, 179, 0.04);border: "1px solid rgba(0, 80, 179, 0.08)}`}</style>
            </Form.Item>
        );
    }

}

export default NormalInput;